import { convertAttendeesToEmailAddressWrappers } from 'owa-calendar-notes-editor/lib/utils/recipientAttendeeConversions';
import createRecipientWell from 'owa-readwrite-recipient-well/lib/utils/createRecipientWell';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import type RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
/**
 * These requiredRecipientWellViewState are temporary until VSO 30418 and VSO 35590 are addressed.
 * They are created here to keep the well in sync with the event when attendees are added from external sources.
 */
function getRequiredRecipientWellViewState(): RecipientWellWithFindControlViewState {
    const event = getComposeStore().event;
    return createRecipientWell(
        null /* findPeopleFeedbackManager */,
        convertAttendeesToEmailAddressWrappers(event.RequiredAttendees),
        event.ParentFolderId.mailboxInfo.userIdentity
    );
}

/**
 * These optionalRecipientWellViewState are temporary until VSO 30418 and VSO 35590 are addressed.
 * They are created here to keep the well in sync with the event when attendees are added from external sources.
 */
function getOptionalRecipientWellViewState(): RecipientWellWithFindControlViewState {
    const event = getComposeStore().event;
    return createRecipientWell(
        null /* findPeopleFeedbackManager */,
        convertAttendeesToEmailAddressWrappers(event.OptionalAttendees),
        event.ParentFolderId.mailboxInfo.userIdentity
    );
}

export { getOptionalRecipientWellViewState, getRequiredRecipientWellViewState };
